import PropTypes from 'prop-types';
import { PureComponent } from 'react';
import styled from 'styled-components';

import { Button, ButtonGroup } from '~/components/Elements';
import Time from '~/components/Time';
import WysiwygText from '~/components/WysiwygText';
import { colors, spacing } from '~/utils/css-mixins';

import { getInterviewText } from './utils';

const StyledWysiwygText = styled(WysiwygText)`
  font-size: 14px;
  line-height: 22px;
`;

const TextHead = styled.div`
  font-size: 18px;
  margin-bottom: 10px;

  time {
    font-weight: 600;
  }
`;

const Wrap = styled.div`
  border-left: 2px solid ${colors.border};
  margin: ${spacing.siteGutter * 2}px 0;
  max-width: ${spacing.siteContentWidth};
`;

const ArchiveItem = styled.div`
  padding: ${spacing.siteGutter}px;

  &:nth-child(even) {
    background-color: ${colors.bgsitecomplementary};
  }
`;

const StyledButtonGroup = styled(ButtonGroup)`
  margin-left: ${spacing.siteGutter}px;
`;

export class Archive extends PureComponent {
  static propTypes = {
    interviews: PropTypes.array.isRequired,
    moreClick: PropTypes.func.isRequired,
    closeClick: PropTypes.func.isRequired,
    total: PropTypes.number.isRequired,
  };

  render() {
    const { interviews, total, moreClick, closeClick } = this.props;

    return (
      <Wrap>
        {interviews.map(interview => (
          <ArchiveItem key={interview.id}>
            <TextHead>
              <Time
                date={new Date(interview.race.meet.race_date)}
                format="yyyy-MM-dd"
              />
              {`, `}
              {interview.race.meet.track.name}
              {`, ${interview.start.driver} `}
              {interview.start.trainer &&
                interview.start.trainer.short_name && (
                  <span>({interview.start.trainer.short_name})</span>
                )}
            </TextHead>

            <StyledWysiwygText
              html={getInterviewText(interview.text, interview.byline)}
            />
          </ArchiveItem>
        ))}

        <StyledButtonGroup>
          {interviews.length < total && (
            <Button size="large" onClick={moreClick}>
              {`Visa fler intervjuer`}
            </Button>
          )}

          <Button size="large" inverse onClick={closeClick}>
            {`Stäng arkiv`}
          </Button>
        </StyledButtonGroup>
      </Wrap>
    );
  }
}

export default Archive;
